import { render, staticRenderFns } from "./indicadores.vue?vue&type=template&id=0e5f23e8&scoped=true&"
import script from "./indicadores.vue?vue&type=script&lang=js&"
export * from "./indicadores.vue?vue&type=script&lang=js&"
import style0 from "./indicadores.vue?vue&type=style&index=0&id=0e5f23e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5f23e8",
  null
  
)

export default component.exports